// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"2f8f7653","787":"5c431a86"}[chunkId] + ".chunk.js";
};